import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
import toast, { Toaster } from "react-hot-toast";
import AIS140Availability from "../../contexts/AIS140Availabilities";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import ProductReviews from "./ProductReviews";
import "./ProductOverview.css"

import Navbar from "./Navbar";
import Footer from "./Footer";
import "./ProductOverview.css";
import DemoSection from "./DemoSection";
import HomepageProducts from "./HomepageProducts";
import {
  FaTruck,
  FaUndo,
  FaExclamationCircle,
  FaShieldAlt,
} from "react-icons/fa";

import { createSlug } from "../../utils/slugify";

function ProductsOverview({ websiteData }) {
  // const { id } = useParams();

  const { slug } = useParams();
  console.log(slug, "slug details")

  // const deviceId = Number(slug?.split("-").pop());

  const location = useLocation();

  // const deviceId = location.state?.deviceId;

  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [isProcessing, setIsProcessing] = useState(false);
  // const deviceId = queryParams.get("deviceId");

  const [quantity, setQuantity] = useState(1);
  const [stateData, setData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [selectedRelayer, setSelectedRelayer] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [deviceReviews, setDeviceReviews] = useState([]);
  const [totalReviews, setTotalReviews] = useState([]);

  // AIS140 states
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [isAIS, setIsAIS] = useState(false);

  const { addToCart, cartItems, updateCartItem, cartLoaded } =
    useContext(CartContext);

  const existingCartItem = cartItems.find(
    (item) =>
      Number(item?.device?.id) === Number(stateData?.selectedDevice?.id),

  );


  const isProductInCart = !!existingCartItem;

  const device = stateData?.selectedDevice;

  console.log(stateData, "state data")

  const relayIncluded =
    device?.isRelay &&
    Number(device?.relayAmt) === 0;

  useEffect(() => {
    if (!cartLoaded || !stateData?.selectedDevice) return;

    const cartItem = cartItems.find(
      (item) =>
        Number(item?.device?.id) === Number(stateData.selectedDevice.id)
    );

    console.log("FOUND CART ITEM", cartItem);

    if (cartItem) {
      console.log("NETWORK", cartItem.network);
      console.log("SUBSCRIPTION", cartItem.subscription);

      setQuantity(cartItem.quantity || 1);
      setSelectedNetwork(cartItem.network || null);
      setSelectedRelayer(!!cartItem.relayer);
      setSelectedSubscription(cartItem.subscription || null);

      setSelectedState(cartItem.state || "");
      setSelectedCity(cartItem.city || "");
    }
  }, [cartLoaded, cartItems, stateData]);


  useEffect(() => {
    if (!websiteData?.length) return;
    if (!slug) return;

    let matchedProduct = null;
    let matchedDevice = null;

    for (const product of websiteData) {
      const foundDevice = product?.device?.find((d) => {
        const deviceSlug = createSlug(
          d.name || d.webProductName
        );

        return deviceSlug === slug;
      });

      if (foundDevice) {
        matchedProduct = product;
        matchedDevice = foundDevice;
        break;
      }
    }

    if (!matchedProduct || !matchedDevice) {
      navigate("/products");
      return;
    }

    setData({
      ...matchedProduct,
      selectedDevice: matchedDevice,
    });

    setIsAIS(
      matchedDevice?.name?.toUpperCase().includes("AIS")
    );

    setSelectedImage(
      matchedDevice?.image?.[1] || null
    );
  }, [slug, websiteData, navigate]);

  useEffect(() => {
    if (!device?.id) return;

    fetchTotalReviews();
  }, [device?.id]);

  useEffect(() => {
    if (!device || isProductInCart) return;

    setSelectedRelayer(
      device.isRelay &&
      Number(device.relayAmt) === 0
    );
  }, [device, isProductInCart]);


  const selectedCityInfo = AIS140Availability[selectedState]?.find(
    (city) => city.name === selectedCity,
  );

  const subscriptionOptions = useMemo(() => {
    if (!device?.isSubscription) return [];

    const options = [];

    if (device.isMonthlySubscription) {
      options.push({
        value: "monthly",
        amount: Number(device.subscriptionMonthlyAmt || 0),
        label:
          Number(device.subscriptionMonthlyAmt) === 0
            ? "1 Month Included"
            : `1 Month (+₹${device.subscriptionMonthlyAmt})`,
      });
    }

    if (device.isYearlySubscription) {
      options.push({
        value: "yearly",
        amount: Number(device.subscriptionYearlyAmt || 0),
        label:
          Number(device.subscriptionYearlyAmt) === 0
            ? "1 Year Included"
            : `1 Year (+₹${device.subscriptionYearlyAmt})`,
      });
    }

    if (device.isTwoYearSubscription) {
      options.push({
        value: "two_year",
        amount: Number(device.subscriptionTwoYearAmt || 0),
        label:
          Number(device.subscriptionTwoYearAmt) === 0
            ? "2 Years Included"
            : `2 Years (+₹${device.subscriptionTwoYearAmt})`,
      });
    }

    return options;
  }, [device]);

  const networkOptions = useMemo(() => {
    if (!device?.isNetwork) return [];

    const options = [];

    if (Number(device.network2gAmt) !== -1) {
      options.push({
        value: "2G",
        amount: Number(device.network2gAmt),
      });
    }

    if (Number(device.network4gAmt) !== -1) {
      options.push({
        value: "4G",
        amount: Number(device.network4gAmt),
      });
    }

    return options;
  }, [device]);

  useEffect(() => {
    if (!networkOptions.length || isProductInCart) return;

    const includedOption = networkOptions.find(
      (option) => option.amount === 0
    );

    setSelectedNetwork(
      includedOption?.value ||
      networkOptions[0]?.value
    );
  }, [networkOptions, isProductInCart]);

  useEffect(() => {
    if (!subscriptionOptions.length || isProductInCart) return;

    const includedPlan = subscriptionOptions.find(
      (item) => item.amount === 0
    );

    setSelectedSubscription(
      includedPlan?.value ||
      subscriptionOptions[0].value
    );
  }, [subscriptionOptions, isProductInCart]);

  const TAX_RATE = 0.18; // 18%

  const round2 = (n) => Math.round(n * 100) / 100;


  // const pricingCalculation = useMemo(() => {
  //   if (!device) {
  //     return {
  //       discountedPrice: 0,
  //       singleItemDiscountedPrice: 0,
  //       totalPrice: 0,
  //       savings: 0,
  //       currentPrice: 0,
  //       minMRP: 0,
  //       maxMRP: 0,
  //       discountPercent: 0,
  //       tax: 0,
  //       baseAmount: 0,
  //       optionsTotal: 0,
  //     };
  //   }

  //   const gstPercent = Number(device.gstPercent || 18);
  //   const discount = Number(device.discount || 0);

  //   const safeAmount = (v) => (Number(v) > 0 ? Number(v) : 0);

  //   const currentDeviceAmount = Number(device.amount || 0);

  //   // =========================
  //   // ADDONS (COMMON)
  //   // =========================
  //   let addons = 0;

  //   if (selectedNetwork === "2G" && Number(device.network2gAmt) > 0) {
  //     addons += (Number(device.network2gAmt));
  //   }

  //   if (selectedNetwork === "4G" && Number(device.network4gAmt) > 0) {
  //     addons += Number(device.network4gAmt);
  //   }

  //   if (selectedRelayer && Number(device.relayAmt) > 0) {
  //     addons += Number(device.relayAmt);
  //   }

  //   const selectedSubscriptionOption = subscriptionOptions.find(
  //     (option) => option.value === selectedSubscription
  //   );

  //   addons += Number(selectedSubscriptionOption?.amount || 0);

  //   // =========================
  //   // CURRENT PRICE (unchanged logic)
  //   // =========================
  //   const currentTax = round2(currentDeviceAmount * (gstPercent / 100));

  //   const currentPrice = round2(
  //     currentDeviceAmount + currentTax + addons
  //   );

  //   // =========================
  //   // DISCOUNTED BASE PRICE
  //   // =========================
  //   // -------------------------
  //   // DISCOUNTED BASE
  //   // -------------------------
  //   let discountedDeviceAmount = currentDeviceAmount;

  //   if (discount > 0) {
  //     discountedDeviceAmount =
  //       discountedDeviceAmount * (1 - discount / 100);
  //   }

  //   // DO NOT round too early
  //   const unitBase = discountedDeviceAmount + addons;
  //   const taxOnUnitBase = round2(round2(unitBase) * (gstPercent / 100))

  //   // STEP 1: multiply (NO rounding)
  //   const subtotal = round2(unitBase * quantity);

  //   // STEP 2: GST on full precision value
  //   const tax = round2(subtotal * (gstPercent / 100));

  //   // STEP 3: FINAL ROUND ONLY HERE
  //   const singleItemDiscountedPrice = round2(unitBase + taxOnUnitBase)
  //   console.log(subtotal, tax, "asjfdniuasfn")
  //   const discountedPrice = round2(subtotal + tax);
  //   console.log(currentPrice, discountedPrice, "asjfdniuasfn")

  //   const totalPrice = discountedPrice;

  //   // =========================
  //   // MRP RANGE (unchanged)
  //   // =========================
  //   const minMRP = round2(
  //     Number(device.amount || 0) +
  //     round2(Number(device.amount || 0) * (gstPercent / 100))
  //   );

  //   const maxNetwork = Math.max(
  //     safeAmount(device.network2gAmt),
  //     safeAmount(device.network4gAmt)
  //   );

  //   const maxSubscription = Math.max(
  //     device.isMonthlySubscription
  //       ? safeAmount(device.subscriptionMonthlyAmt)
  //       : 0,
  //     device.isYearlySubscription
  //       ? safeAmount(device.subscriptionYearlyAmt)
  //       : 0,
  //     device.isTwoYearSubscription
  //       ? safeAmount(device.subscriptionTwoYearAmt)
  //       : 0
  //   );

  //   const maxRelay = safeAmount(device.relayAmt);

  //   const maxMRP = round2(minMRP + maxNetwork + maxSubscription + maxRelay);

  //   return {
  //     discountedPrice,
  //     singleItemDiscountedPrice,
  //     totalPrice,

  //     savings: round2((currentPrice - singleItemDiscountedPrice) * quantity),

  //     currentPrice,

  //     minMRP,
  //     maxMRP,

  //     discountPercent: discount,

  //     tax,

  //     baseAmount: round2(unitBase),
  //   };
  // }, [
  //   device,
  //   selectedNetwork,
  //   selectedRelayer,
  //   selectedSubscription,
  //   quantity,
  //   subscriptionOptions,
  // ]);

  const pricingCalculation = useMemo(() => {
    if (!device) {
      return {
        discountedPrice: 0,
        singleItemDiscountedPrice: 0,
        totalPrice: 0,
        savings: 0,
        currentPrice: 0,
        minMRP: 0,
        maxMRP: 0,
        discountPercent: 0,
        tax: 0,
        baseAmount: 0,
        optionsTotal: 0,
      };
    }

    const gstPercent = Number(device.gstPercent || 18);
    const discount = Number(device.discount || 0);

    const safeAmount = (v) => (Number(v) > 0 ? Number(v) : 0);

    const currentDeviceAmount = Number(device.amount || 0);

    // =========================
    // ADDONS
    // =========================
    let addons = 0;

    if (
      selectedNetwork === "2G" &&
      Number(device.network2gAmt) > 0
    ) {
      addons += Number(device.network2gAmt);
    }

    if (
      selectedNetwork === "4G" &&
      Number(device.network4gAmt) > 0
    ) {
      addons += Number(device.network4gAmt);
    }

    if (
      selectedRelayer &&
      Number(device.relayAmt) > 0
    ) {
      addons += Number(device.relayAmt);
    }

    const selectedSubscriptionOption =
      subscriptionOptions.find(
        (option) =>
          option.value === selectedSubscription
      );

    addons += Number(
      selectedSubscriptionOption?.amount || 0
    );

    // =========================
    // CURRENT PRICE
    // (GST ONLY ON DEVICE PRICE)
    // =========================
    const currentTax = round2(
      currentDeviceAmount * (gstPercent / 100)
    );

    const currentPrice = round2(
      currentDeviceAmount +
      currentTax +
      addons
    );

    // =========================
    // DISCOUNTED DEVICE AMOUNT
    // =========================
    let discountedDeviceAmount =
      currentDeviceAmount;

    if (discount > 0) {
      discountedDeviceAmount =
        discountedDeviceAmount *
        (1 - discount / 100);
    }

    // GST ONLY ON DEVICE AMOUNT
    const taxOnDevice = round2(
      discountedDeviceAmount *
      (gstPercent / 100)
    );

    const unitBase = discountedDeviceAmount + addons;
    const taxOnUnitBase = round2(round2(discountedDeviceAmount*1) * (gstPercent / 100))

    // Per item price
    const singleItemDiscountedPrice = round2(
      unitBase +
      taxOnUnitBase
    );

    // Quantity calculations
    const subtotal = (
      (discountedDeviceAmount + addons) *
      quantity
    );

    const subtotalWithQty = round2(
      (discountedDeviceAmount) *
      quantity
    );

    const totalTax = round2(
      subtotalWithQty *
      (gstPercent / 100)
    );

    const discountedPrice = round2(
      subtotal + totalTax
    );

    console.log(unitBase, taxOnUnitBase, singleItemDiscountedPrice, "aaaaa")

    console.log(subtotal, totalTax, discountedPrice, "bfdiufifi")

    const totalPrice = discountedPrice;

    // =========================
    // MRP RANGE
    // =========================
    const minMRP = round2(
      Number(device.amount || 0) +
      round2(
        Number(device.amount || 0) *
        (gstPercent / 100)
      )
    );

    const maxNetwork = Math.max(
      safeAmount(device.network2gAmt),
      safeAmount(device.network4gAmt)
    );

    const maxSubscription = Math.max(
      device.isMonthlySubscription
        ? safeAmount(
          device.subscriptionMonthlyAmt
        )
        : 0,
      device.isYearlySubscription
        ? safeAmount(
          device.subscriptionYearlyAmt
        )
        : 0,
      device.isTwoYearSubscription
        ? safeAmount(
          device.subscriptionTwoYearAmt
        )
        : 0
    );

    const maxRelay = safeAmount(
      device.relayAmt
    );

    const maxMRP = round2(
      minMRP +
      maxNetwork +
      maxSubscription +
      maxRelay
    );

    return {
      discountedPrice,
      singleItemDiscountedPrice,
      totalPrice,

      savings: round2(
        (currentPrice -
          singleItemDiscountedPrice) *
        quantity
      ),

      currentPrice,

      minMRP,
      maxMRP,

      discountPercent: discount,

      tax: totalTax,

      baseAmount: round2(
        discountedDeviceAmount + addons
      ),

      optionsTotal: addons,
    };
  }, [
    device,
    selectedNetwork,
    selectedRelayer,
    selectedSubscription,
    quantity,
    subscriptionOptions,
  ]);

  // const pricingCalculation = useMemo(() => {
  //   if (!device) {
  //     return {
  //       discountedPrice: 0,
  //       totalPrice: 0,
  //       savings: 0,
  //       currentPrice: 0,
  //       minMRP: 0,
  //       maxMRP: 0,
  //       discountPercent: 0,
  //       tax: 0,
  //       baseAmount: 0,
  //     };
  //   }

  //   const gstPercent = Number(device.gstPercent || 18);
  //   const discount = Number(device.discount || 0);

  //   const safeAmount = (v) =>
  //     Number(v) > 0 ? Number(v) : 0;

  //   // =========================
  //   // CURRENT PRICE
  //   // =========================

  //   const currentDeviceAmount = Number(device.amount || 0);

  //   let currentAddons = 0;

  //   if (
  //     selectedNetwork === "2G" &&
  //     Number(device.network2gAmt) > 0
  //   ) {
  //     currentAddons += Number(device.network2gAmt);
  //   }

  //   if (
  //     selectedNetwork === "4G" &&
  //     Number(device.network4gAmt) > 0
  //   ) {
  //     currentAddons += Number(device.network4gAmt);
  //   }

  //   if (
  //     selectedRelayer &&
  //     Number(device.relayAmt) > 0
  //   ) {
  //     currentAddons += Number(device.relayAmt);
  //   }

  //   if (selectedSubscription === "monthly") {
  //     currentAddons += Number(
  //       device.subscriptionMonthlyAmt || 0
  //     );
  //   }

  //   if (selectedSubscription === "yearly") {
  //     currentAddons += Number(
  //       device.subscriptionYearlyAmt || 0
  //     );
  //   }

  //   if (selectedSubscription === "two_year") {
  //     currentAddons += Number(
  //       device.subscriptionTwoYearAmt || 0
  //     );
  //   }

  //   const currentTax = round2(
  //     currentDeviceAmount *
  //     (gstPercent / 100)
  //   );

  //   const currentPrice = round2(
  //     currentDeviceAmount +
  //     currentTax +
  //     currentAddons
  //   );

  //   // =========================
  //   // DISCOUNTED PRICE
  //   // =========================

  //   let discountedDeviceAmount =
  //     Number(device.amount || 0);

  //   if (discount > 0) {
  //     discountedDeviceAmount =
  //       discountedDeviceAmount *
  //       (1 - discount / 100);
  //   }

  //   let addons = 0;

  //   if (
  //     selectedNetwork === "2G" &&
  //     Number(device.network2gAmt) > 0
  //   ) {
  //     addons += Number(device.network2gAmt);
  //   }

  //   if (
  //     selectedNetwork === "4G" &&
  //     Number(device.network4gAmt) > 0
  //   ) {
  //     addons += Number(device.network4gAmt);
  //   }

  //   if (
  //     selectedRelayer &&
  //     Number(device.relayAmt) > 0
  //   ) {
  //     addons += Number(device.relayAmt);
  //   }

  //   const selectedSubscriptionOption =
  //     subscriptionOptions.find(
  //       (option) =>
  //         option.value === selectedSubscription
  //     );

  //   addons += Number(
  //     selectedSubscriptionOption?.amount || 0
  //   );

  //   discountedDeviceAmount =
  //     round2(discountedDeviceAmount);

  //   const tax = (
  //     discountedDeviceAmount *
  //     (gstPercent / 100)
  //   );

  //   const discountedPrice = round2(
  //     discountedDeviceAmount +
  //     tax +
  //     addons
  //   );

  //   const totalPrice = round2(
  //     discountedPrice * quantity
  //   );

  //   // =========================
  //   // MRP RANGE
  //   // =========================

  //   const minMRP = round2(
  //     Number(device.amount || 0) +
  //     round2(
  //       Number(device.amount || 0) *
  //       (gstPercent / 100)
  //     )
  //   );

  //   const maxNetwork = Math.max(
  //     safeAmount(device.network2gAmt),
  //     safeAmount(device.network4gAmt)
  //   );

  //   const maxSubscription = Math.max(
  //     device.isMonthlySubscription
  //       ? safeAmount(
  //         device.subscriptionMonthlyAmt
  //       )
  //       : 0,

  //     device.isYearlySubscription
  //       ? safeAmount(
  //         device.subscriptionYearlyAmt
  //       )
  //       : 0,

  //     device.isTwoYearSubscription
  //       ? safeAmount(
  //         device.subscriptionTwoYearAmt
  //       )
  //       : 0
  //   );

  //   const maxRelay = safeAmount(
  //     device.relayAmt
  //   );

  //   const maxMRP = round2(
  //     minMRP +
  //     maxNetwork +
  //     maxSubscription +
  //     maxRelay
  //   );

  //   return {
  //     discountedPrice,
  //     totalPrice,

  //     savings: round2(
  //       currentPrice -
  //       discountedPrice
  //     ),

  //     currentPrice,

  //     minMRP,
  //     maxMRP,

  //     discountPercent: discount,

  //     tax,

  //     baseAmount: round2(
  //       discountedDeviceAmount + addons
  //     ),
  //   };
  // }, [
  //   device,
  //   selectedNetwork,
  //   selectedRelayer,
  //   selectedSubscription,
  //   quantity,
  //   subscriptionOptions,
  // ]);

  const fetchTotalReviews = async () => {
    try {
      const response = await ApiService.post("review/getReviewsByDevice", {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
        deviceId: device?.id,
      });

      if (response.status) {
        const data = response.data;
        // const deviceReviews = data.filter(
        //   (item) => item.deviceId.id === device.id
        // );
        setTotalReviews(data);
        // const filteredDeviceReviews = data.filter(review => review.deviceId?.id === Number(deviceId))
        setDeviceReviews(data);
      } else {
        console.error("Error while fetching the reviews");
      }
    } catch (err) {
      console.error("Error fetching revies");
    }
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setSelectedCity("");
  };

  const handleCityChange = (e) => setSelectedCity(e.target.value);

  const isBuyDisabled = isAIS
    ? !selectedState || !selectedCity || !selectedCityInfo?.availability
    : false;

  const handleAddToCart = async () => {
    if (isProcessing || !device) return;

    setIsProcessing(true);

    try {
      if (isAIS && (!selectedState || !selectedCity)) {
        toast.error("Please select your state and city");
        return;
      }

      const cartItem = {
        deviceId: device.id,
        product: stateData,
        quantity,

        // ✅ single source
        price: pricing.unitFinalPrice,
        totalAmount: pricing.totalPrice,

        name: device.name,
        model: device.model,
        discount: device.discount || 0,

        network: selectedNetwork,
        isRelay: device.isRelay,
        relayer: selectedRelayer,
        subscription: selectedSubscription,
        state: selectedState,
        city: selectedCity,
      };

      if (isProductInCart) {
        await updateCartItem(existingCartItem, cartItem);
        // toast.success("Product updated in cart!");
      } else {
        await addToCart(cartItem);
        // toast.success("Product added to cart!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleBuyNow = async () => {
    await handleAddToCart();
    navigate("/cart");
  };


  const incrementQuantity = () => setQuantity((prev) => prev + 1);
  const decrementQuantity = () =>
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const pricing = pricingCalculation;

  if (!cartLoaded) {
    return <div>Loading product...</div>;
  }

  return (
    <div className="product-overview-body">
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      {/* <Navbar /> */}

      <div className="product-overview-mining-product">
        <div className="mining-product-gallery">
          <div className="mining-product-thumbnails">
            {device?.image?.slice(1).map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumbnail ${index + 1}`}
                className={`thumbnail ${selectedImage === img ? "active" : ""}`}
                onClick={() => setSelectedImage(img)}
              />
            ))}
          </div>

          <div className="mining-product-main">
            <img
              src={selectedImage || device?.image?.[1]}
              alt="Main product"
              className="main-image"
              onError={(e) =>
                (e.target.src = "/images/placeholder-product.png")
              }
            />
          </div>
        </div>

        <div className="mining-product-details">
          <div className="mining-product-title">
            <h2 className="mining-product-title-h2">
              {device?.name} {device?.model}
            </h2>
          </div>

          <div className="mining-product-features">
            <ul>
              <li>{device?.description}</li>
            </ul>
          </div>

          <div className="mining-product-order">
            <div className="extra-product-details">
              {/* Relayer Option */}
              {device?.isRelay && (
                <div className="extra-detail-card">
                  <h3 className="option-headings">Relayer Option:</h3>
                  <div className="option-btns">
                    {/* Included case */}
                    {/* {device.relayAmt === 0 ? (
                      <button className="option-btn active">
                        Relay - Included
                      </button>
                    ) : (
                      <>
                        <button
                          className={`option-btn ${selectedRelayer === "without" ? "active" : ""}`}
                          onClick={() => setSelectedRelayer("without")}
                        >
                          Without Relay
                        </button>

                        <button
                          className={`option-btn ${selectedRelayer === "with" ? "active" : ""}`}
                          onClick={() => setSelectedRelayer("with")}
                        >
                          Relay - Included
                        </button>
                      </>
                    )} */}

                    {Number(device.relayAmt) === 0 ? (
                      <button className="option-btn active">
                        Relay Included
                      </button>
                    ) : (
                      <>
                        <button
                          className={`option-btn ${!selectedRelayer ? "active" : ""}`}
                          onClick={() => setSelectedRelayer(false)}
                        >
                          Without Relay
                        </button>

                        <button
                          className={`option-btn ${selectedRelayer ? "active" : ""}`}
                          onClick={() => setSelectedRelayer(true)}
                        >
                          With Relay (+₹{device.relayAmt})
                        </button>
                      </>
                    )}
                  </div>

                </div>
              )}

              {/* Network Options */}
              {device?.isNetwork &&
                !(
                  device?.network2gAmt === -1 && device?.network4gAmt === -1
                ) && (
                  <div className="extra-detail-card">
                    <h3 className="option-headings">Network Options</h3>

                    <div className="option-btns">
                      {networkOptions.map((network) => (
                        <button
                          key={network.value}
                          className={`option-btn ${selectedNetwork === network.value
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setSelectedNetwork(network.value)
                          }
                        >
                          {network.value}
                          {network.amount === 0
                            ? " Included"
                            : ` (+₹${network.amount})`}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

              {/* {device?.isNetwork && (
                <div className="extra-detail-card">
                  <h3 className="option-headings">Network:</h3>

                  <div className="option-btns">
                    <button className="option-btn active">Airtel</button>
                  </div>
                  {device.network2gAmt === 0 && device.network4gAmt === 0 ? (
                    <p className="option-note">2G & 4G Included</p>
                  ) : (
                    <p className="option-note">
                      Network charges applied based on plan
                    </p>
                  )}
                </div>
              )} */}

              {/* Subscription Options */}
              {/* {device?.isSubscription &&
                (device?.subscriptionMonthlyAmt > 0 ||
                  device?.subscriptionYearlyAmt > 0) && (
                  <div className="extra-detail-card">
                    <h3 className="option-headings">Subscription</h3>
                    <div className="option-btns">
                      {device?.subscriptionMonthlyAmt > 0 && (
                        <button
                          className={`option-btn ${selectedSubscription === "monthly" ? "active" : ""
                            }`}
                          onClick={() => setSelectedSubscription("monthly")}
                        >
                          Monthly – ₹{device?.subscriptionMonthlyAmt}
                        </button>
                      )}
                      {device?.subscriptionYearlyAmt > 0 && (
                        <button
                          className={`option-btn ${selectedSubscription === "yearly" ? "active" : ""
                            }`}
                          onClick={() => setSelectedSubscription("yearly")}
                        >
                          Yearly – ₹{device?.subscriptionYearlyAmt}
                        </button>
                      )}
                    </div>
                  </div>
                )} */}

              {device?.isSubscription && (
                <div className="extra-detail-card">
                  <h3 className="option-headings">Subscription:</h3>

                  <div className="option-btns">
                    {subscriptionOptions.map((option) => (
                      <button
                        key={option.value}
                        className={`option-btn ${selectedSubscription === option.value
                          ? "active"
                          : ""
                          }`}
                        onClick={() =>
                          setSelectedSubscription(option.value)
                        }
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>

                  {/* <div className="option-btns">
                    {device.subscriptionYearlyAmt === 0 ? (
                      <button className="option-btn active">
                        1 year subscription included
                      </button>
                    ) : (
                      <>
                        <button
                          className={`option-btn ${selectedSubscription === "monthly" ? "active" : ""}`}
                          onClick={() => setSelectedSubscription("monthly")}
                        >
                          1
                          month subscription
                        </button>

                        <button
                          className={`option-btn ${selectedSubscription === "yearly" ? "active" : ""}`}
                          onClick={() => setSelectedSubscription("yearly")}
                        >
                          1 year
                          subscription
                        </button>
                      </>
                    )}
                  </div> */}

                  {/* Description */}
                  {/* <p className="option-note">
                    {selectedSubscription === "yearly"
                      ? "1 year subscription included"
                      : "1 month subscription included"}
                  </p> */}
                </div>
              )}

              {/* AIS CONSITIONS */}
              {isAIS && (
                <div className="extra-detail-card">
                  <h3 className="option-headings">Location (AIS Only)</h3>
                  <div className="option-btns">
                    <select
                      id="ais-state"
                      name="aisState"
                      className="ProductOverview-selected"
                      value={selectedState || ""}
                      onChange={handleStateChange}
                    >
                      <option value="">Select State</option>
                      {Object.keys(AIS140Availability).map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>

                    <select
                      id="ais-city"
                      name="aisCity"
                      className="ProductOverview-selected"
                      value={selectedCity || ""}
                      onChange={handleCityChange}
                      disabled={!selectedState}
                    >
                      <option value="">Select City</option>
                      {selectedState &&
                        AIS140Availability[selectedState].map((city) => (
                          <option
                            key={city.name}
                            value={city.name}
                            disabled={!city.availability}
                          >
                            {city.name}{" "}
                            {city.availability ? "" : "(Unavailable)"}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* {selectedCityInfo && (
                    <div style={{ marginTop: "10px" }}>
                      <strong>Price:</strong> ₹{selectedCityInfo.price} <br />
                      <strong>Available:</strong>{" "}
                      {selectedCityInfo.availability ? "Yes" : "No"}
                    </div>
                  )} */}
                </div>
              )}
            </div>

            {/* <div className="mining-product-final-price">
              <p className="productoverview-price">
                Total Price : ₹ <strong className="total-price">
                  {pricing.totalPrice.toFixed(2)}
                </strong>
              </p>

            </div> */}

            {/* <div className="product-overview-price-box">

              {pricingCalculation.minMRP < pricingCalculation.maxMRP && (
                <p className="product-overview-mrp-range">
                  MRP Range: ₹{pricingCalculation.minMRP.toFixed(0)} – ₹{pricingCalculation.maxMRP.toFixed(0)}
                </p>
              )}

              <div className="product-overview-price-row">
                <span className="product-overview-final-price">
                  ₹{pricingCalculation.discountedPrice.toFixed(0)}
                </span>
                {pricingCalculation.discountPercent > 0 && (
                  <span className="product-overview-discount-badge">
                    {pricingCalculation.discountPercent}% OFF
                  </span>
                )}
              </div>

              <p className="product-overview-current-price">
                Current Price: ₹{pricingCalculation.currentPrice.toFixed(0)} (Inclusive of all taxes)
              </p>

              <p className="product-overview-selected-options">
                Options Selected:{" "}
                {selectedNetwork && `Network: ${selectedNetwork} (+₹${selectedNetwork === '2G' ? device.network2gAmt : device.network4gAmt})`}
                {selectedRelayer && `, Relayer: +₹${device.relayAmt}`}
                {selectedSubscription && `, Subscription: +₹${selectedSubscription === 'monthly' ? device.subscriptionMonthlyAmt : device.subscriptionYearlyAmt}`}
              </p>

            </div> */}

            <div className="product-overview-price-box">
              {/* MRP Range */}
              {pricingCalculation.minMRP < pricingCalculation.maxMRP && (
                <p className="product-overview-mrp-range">
                  MRP Range: ₹{pricingCalculation.minMRP.toFixed(2)} – ₹
                  {pricingCalculation.maxMRP.toFixed(2)}
                </p>
              )}

              <div className="product-overview-price-row">
                <span className="product-overview-final-price">
                  ₹{pricingCalculation.singleItemDiscountedPrice.toFixed(2)}
                </span>
                <span className="product-overview-per-item">/ item</span>

                {pricingCalculation.currentPrice > 0 && (
                  <span className="product-overview-old-price">
                    ₹{pricingCalculation.currentPrice.toFixed(2)}
                  </span>
                )}

                {device?.discount > 0 && (
                  <span className="product-overview-discount-badge">
                    ~{device.discount}% OFF
                  </span>
                )}
              </div>

              {/* <p className="product-overview-save-text">
                You save ₹{pricingCalculation.savings.toFixed(2)}
                {device?.discount > 0 && ` (~${device.discount}%)`}
              </p> */}

              {pricingCalculation.optionsTotal > 0 && (
                <p className="product-overview-addons">
                  Add-ons: ₹{pricingCalculation.optionsTotal}
                </p>
              )}

              <p className="product-overview-quantity-info">
                {quantity} × ₹{pricingCalculation.singleItemDiscountedPrice.toFixed(2)}
              </p>

              <div className="product-overview-total">
                <span>Item Total: </span>
                <span className="product-overview-total-price">
                  ₹{pricingCalculation.totalPrice.toFixed(2)}
                </span>
              </div>

              <p className="product-overview-tax-text">
                Inclusive of all taxes
              </p>

              <p className="product-overview-save-text">
                You save ₹{pricingCalculation.savings.toFixed(2)}
                {device?.discount > 0 && ` (~${device.discount}%)`}
              </p>

              <div className="product-overview-disclaimers">
                <div className="disclaimer-item">
                  <FaTruck className="disclaimer-icon" />
                  <span>Free shipping on orders above ₹3000 (min 2 items)</span>
                </div>
                <div className="disclaimer-item">
                  <FaShieldAlt className="disclaimer-icon" />
                  <span>1-year warranty (manufacturing defects only)</span>
                </div>
                {/* 
                <div className="disclaimer-item">
                  <FaExclamationCircle className="disclaimer-icon warning" />
                  <span>Shipping charges may apply if order is modified later</span>
                </div>

                <div className="disclaimer-item">
                  <FaUndo className="disclaimer-icon" />
                  <span>Replacement available. No refunds after shipping</span>
                </div> */}
              </div>

              <div className="product-overview-trust">
                <span className="trust-item">
                  Orders can’t be cancelled once confirmed after verification
                </span>
                {/* <span className="trust-dot">•</span> */}
                {/* <span className="trust-item">1-year warranty</span> */}
                <span className="trust-dot">•</span>
                <span className="trust-item">
                  {" "}
                  Use responsibly as per regulations
                </span>
              </div>
            </div>

            <div className="mining-product-quantity">
              <div className="mining-product-quantity-controls">
                <div className="mining-product-quantity-selector">
                  <div className="mining-product-quantity-value">
                    <p>{quantity}</p>
                  </div>
                  <div className="mining-product-quantity-btns">
                    <div className="mining-product-quantity-btns-container">
                      <button
                        className="quantity-up"
                        onClick={incrementQuantity}
                      >
                        <img
                          className="arrow-up"
                          src="/images/up-arrows.png"
                          alt="Increase quantity"
                        />
                      </button>
                      <button
                        className="quantity-down"
                        onClick={decrementQuantity}
                      >
                        <img
                          className="arrow-down"
                          src="/images/arrow-down-sign-to-navigate.png"
                          alt="Decrease quantity"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                {/* <button onClick={handleAddToCart} className="add-to-cart-btn">
                  Add to Cart
                </button> */}

                {/* <button onClick={handleAddToCart} className="add-to-cart-btn">
                  {isProductInCart ? "Update Product" : "Add to Cart"}
                </button> */}
                <button
                  onClick={handleAddToCart}
                  className="add-to-cart-btn"
                  disabled={isProcessing}
                >
                  {isProcessing
                    ? "Processing..."
                    : isProductInCart
                      ? "Update Product"
                      : "Add to Cart"}
                </button>
                <button onClick={handleBuyNow} className="buy-it-now-btn">
                  Buy it now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mining-specification-title">
        <h1>{device?.name}</h1>
      </div>

      <div className="mining-features">
        {(() => {
          const startIndex = stateData?.layoutType === "theme1" ? 3 : 0;
          return (
            <>
              {device?.points?.[0] && (
                <div className="mining-feature-left">
                  <div className="">
                    <img
                      src={device?.points[0]?.file}
                      alt={device?.points[0]?.title}
                    // onError={(e) => (e.target.src = "/images/placeholder-icon.png")}
                    />
                  </div>
                  <div className="mining-feature-title">
                    <p>{device?.points[0]?.title}</p>
                  </div>
                  <div className="mining-feature-desc">
                    <p>{device?.points[0]?.desc}</p>
                  </div>
                </div>
              )}

              <div className="mining-feature-right">
                {device?.points?.[1] && (
                  <div className="mining-feature-top">
                    <div className="mining-feature-top-content">
                      <div className="mining-feature-top-icon">
                        <img
                          src={device?.points[1]?.file}
                          alt={device?.points[1]?.title}
                        // onError={(e) =>
                        //   (e.target.src = "/images/placeholder-icon.png")
                        // }
                        />
                      </div>
                      <div className="mining-feature-top-title">
                        <p>{device?.points[1]?.title}</p>
                      </div>
                      <div className="mining-feature-top-desc">
                        <p>{device?.points[1]?.desc}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mining-feature-bottom">
                  {device?.points?.slice(2, 4).map((point, i) => (
                    <div key={i} className="mining-feature-card">
                      <div className="">
                        <img
                          src={point.file}
                          alt={point.title}
                        // onError={(e) =>
                        //   (e.target.src = "/images/placeholder-icon.png")
                        // }
                        />
                      </div>
                      <div className="mining-feature-card-title">
                        <p>{point.title}</p>
                      </div>
                      <div className="mining-feature-card-desc">
                        <p>{point.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        })()}
      </div>

      <div className="mining-benefits-section">
        <h2 className="mining-benefits-header">Benefits of {device?.name}</h2>
        <div className="mining-benefits-grid">
          {device?.points?.slice(4, 10).map((point, index) => (
            <div key={index} className="mining-benefit-card">
              <div className="mining-benefit-icon">
                <img
                  src={point.file}
                  alt={point.title}
                // onError={(e) => (e.target.src = "/images/placeholder-icon.png")}
                />
              </div>
              <div className="mining-benefit-title">
                <h3>{point.title}</h3>
              </div>
              <div className="mining-benefit-desc">{point.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="product-overview-reviews-section">
        <ProductReviews reviews={deviceReviews} />
      </div>

      <div className="mining-view-more-section">
        <div className="mining-view-more-text">
          <h1>
            Want to see more ? <br />
            Check our remaining products
          </h1>
        </div>
        <div className="mining-view-more">
          <button
            className="view-more-btn"
            onClick={() => {
              navigate("/products");
              window.scrollTo(0, 0);
            }}
          >
            <span>View more</span>
            <div className="view-more-icon">
              <img src="/images/Arrow 11.png" alt="arrow" />
            </div>
          </button>
        </div>
      </div>

      <div className="product-overview-homepage-products-container">
        <HomepageProducts />
      </div>

      <DemoSection />
      {/* <Footer /> */}
    </div>
  );
}

export default ProductsOverview;
